import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "button"]

  connect() {
    if (this.hasDialogTarget) {
      setTimeout(() => {
        this.dialogTarget.classList.add("hidden")
      }, 5000)
    }

    if (this.hasButtonTarget) {
      this.buttonTarget.addEventListener("click", () => {
        if (this.hasDialogTarget) {
          this.dialogTarget.classList.add("hidden")
        }
      })
    }
  }
}
